import React, { ReactElement } from 'react';
import { Navigation, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import { FrontPageState } from '../../../reducer';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/autoplay';
import CarouselItem from '../../../domain/CarouselItem';
import SectionErrorBoundary from './SectionErrorBoundary';

interface MaybeLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href?: string;
}

function MaybeLink({ href, children, ...props }: MaybeLinkProps): ReactElement {
  if (href) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
  return <>{children}</>;
}

const backgroundCss = (image: string): React.CSSProperties => ({
  backgroundImage: `url("${image}")`,
});

function CarouselSlide({ item }: { item: CarouselItem }): ReactElement {
  if (item.linkPlacement === 'text') {
    return (
      <>
        <div className="front-slide-item" style={backgroundCss(item.image)}>
          <MaybeLink href={item.link} tabIndex={-1}>
            <span>{item.text || <>&nbsp;</>}</span>
          </MaybeLink>
        </div>
      </>
    );
  }
  return (
    <MaybeLink href={item.link}>
      <div className="front-slide-item" style={backgroundCss(item.image)}>
        <span>{item.text || <>&nbsp;</>}</span>
      </div>
    </MaybeLink>
  );
}

export default function CarouselSection(): ReactElement {
  const { carousel } = useSelector((state: FrontPageState) => ({
    carousel: state.carousel,
  }));
  if (carousel.items.length === 0) {
    return null;
  }
  return (
    <SectionErrorBoundary name="CarouselSection" message="">
      <section id="start-carousel" className="start-section border-xl">
        <Swiper
          modules={[Navigation, A11y, Autoplay]}
          autoplay={{
            delay: carousel.delay,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          navigation
          loop
          slidesPerView={1}
        >
          {carousel.items.map((item) => (
            <SwiperSlide key={item.id}>
              <CarouselSlide item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </SectionErrorBoundary>
  );
}
